import type { CopilotMode } from '@terra/shared-dto-chat-types';

const MODE_CYCLE_ORDER: readonly CopilotMode[] = ['agent', 'plan', 'ask'];

export function getNextCycledCopilotMode(
  currentMode: CopilotMode,
): CopilotMode {
  const index = MODE_CYCLE_ORDER.indexOf(currentMode);

  if (index < 0) {
    return MODE_CYCLE_ORDER[0];
  }

  return MODE_CYCLE_ORDER[(index + 1) % MODE_CYCLE_ORDER.length];
}

export type ComposerShortcutKeyInput = {
  key: string;
  shiftKey?: boolean;
  metaKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
};

export type ComposerShortcutAction =
  | 'stop-streaming'
  | 'dismiss-slash-menu'
  | 'cycle-mode'
  | 'open-command-palette';

export function resolveComposerKeyboardShortcut({
  event,
  isSlashMenuOpen,
  isStreaming,
}: {
  event: ComposerShortcutKeyInput;
  isSlashMenuOpen: boolean;
  isStreaming: boolean;
}): ComposerShortcutAction | null {
  if (
    event.key === 'Escape' &&
    !event.shiftKey &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.altKey
  ) {
    if (isSlashMenuOpen) {
      return 'dismiss-slash-menu';
    }

    if (isStreaming) {
      return 'stop-streaming';
    }

    return null;
  }

  if (
    event.key === 'Tab' &&
    Boolean(event.shiftKey) &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.altKey
  ) {
    return 'cycle-mode';
  }

  if (
    (event.key === 'k' || event.key === 'K') &&
    (Boolean(event.metaKey) || Boolean(event.ctrlKey)) &&
    !event.shiftKey &&
    !event.altKey
  ) {
    return 'open-command-palette';
  }

  return null;
}
